// @flow
import React from 'react'
import MopinionForm from 'react-mopinion-forms';

const FORM_BY_LANGUAGE = {
  'en': 'bb770e01fba657bb9f8a79aa827adb88397144b3',
  'es': '0fca4f4af3282c2cb194696d1a322b645ef024a0',
  'fr': 'cceaf87777a61c0031bb8a27ec25d5505cc24c95'
};

const getFeedbackForm = (userLanguage: string) => {
  const formKey = FORM_BY_LANGUAGE[userLanguage] || FORM_BY_LANGUAGE['en'];
  return (
    <MopinionForm formKey={formKey} />
  );
};


export default {
  getFeedbackForm
};



// WEBPACK FOOTER //
// ./src/util/feedback-util.js